module.exports = __webpack_public_path__ + "img/zfr4.1.a01bf3ee.jpg";